import PlayerPage from "./PlayerPage";

export default PlayerPage;
